import { render, staticRenderFns } from "./DocumentationAPIs.vue?vue&type=template&id=99e115b2"
import script from "./DocumentationAPIs.vue?vue&type=script&lang=js"
export * from "./DocumentationAPIs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports